import React from 'react'
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom';

const duration = 500;


const Client: React.FC<any> = ({ group, blocks }) => {
   
    return (
        <>
            <div className="home-client">
                <div className="container-fluid">
                    <Fade direction="down" delay={0}>
                    <div className="row">
                        <div className="col-md-12 client_box">
                            <Fade direction="down">
                            <h2 dangerouslySetInnerHTML={{__html:group?.title}}></h2>
                            </Fade>
                            
                            <div className="grid">
                            
                                {blocks?.map((row:any , index) => (
                                    
                                    <Fade direction={(index % 2 == 0)?"left":"right"} delay={duration} key={index}>
                                    <div>
                                        <img src={row.file} alt={row.title}/>
                                    </div>
                                     </Fade>
                                ))}

                            </div>
                            
                            

                            <div className="text-center">
                                <button>
                                <Link to={group?.cta} style={{color:"white"}}>{group?.cta_text}</Link>
                                </button>
                            </div>
                        </div>
                    </div>
                    </Fade>
                </div>
            </div>
        </>
    )
}
export default Client